import { Button, Flex, getThemeMedia, getThemeShadow } from 'front-commons/ds';
import styled from 'styled-components';

export const Wrapper = styled(Flex)`
	position: relative;
	height: 100%;
	overflow-y: auto;

	[data-testid='add-to-cart-counter'] {
		height: 40px;
	}
`;

export const SearchInputContainer = styled.div`
	gap: 1rem;
	display: flex;
	flex-direction: column;

	i {
		left: -6px;
	}

	input {
		padding-left: 2.5rem;
	}
`;

export const ProductCards = styled(Flex)`
	padding: 1rem;
	gap: 1.5rem;
	flex-direction: column;
	flex: 1;
	flex-grow: 0;

	border: 1px solid var(--border-primary);
	border-radius: 8px;

	> div:not(:last-child) {
		padding-bottom: 1rem;

		border-bottom: 1px solid var(--border-primary);
	}
`;

export const FooterPromotionDetails = styled(Flex)`
	padding: 1.5rem;
	gap: 1rem;
	flex-direction: column;
	bottom: 0;
	z-index: 1;
	position: sticky;

	background-color: var(--surface-white);
	box-shadow: inset ${getThemeShadow('1')};

	p {
		text-align: center;
	}
`;

export const SummarySeparator = styled.hr`
	height: 1px;

	border: none;
	background-color: var(--border-primary);
`;

export const ButtonsContainer = styled(Flex)`
	width: 100%;
	gap: 0.5rem;
	flex-direction: column;
	align-items: center;

	button[data-testid='add-to-cart'] {
		max-width: none;
	}

	@media screen {
		@media (min-width: ${getThemeMedia('medium')}) {
			flex-direction: row;
			justify-content: end;

			button[data-testid='add-to-cart'] {
				max-width: 240px;
			}
		}
	}
`;

export const ChangeDistributorsButton = styled(Button)`
	p {
		font-weight: 600;
	}
`;
